export const Content1DataSource = {
  wrapper: { className: 'home-page-wrapper ota-content1-wrapper' },
  page: { className: 'home-page ota-content1' },
  OverPack: { playScale: 0.1 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        className: 'title-h1',
        children: 'product.ota.platform'
      },
      {
        name: 'sub-title',
        className: 'sub-title',
        children: 'eSync OTA PLATFORM'
      },
      {
        name: 'content',
        className: 'content',
        children: 'product.ota.introduce'
      }
    ],
  },
};
export const Content2DataSource = {
  wrapper: { className: 'home-page-wrapper content2-wrapper' },
  page: { className: 'home-page content2' },
  OverPack: { playScale: 0.1 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        className: 'title-h1',
        children: 'product.ota.overallPlan'
      },
      {
        name: 'sub-title',
        className: 'sub-title',
        children: 'HOLISTIC PROGRAMME'
      },
    ],
  },
};

export const Content3DataSource = {
  wrapper: { className: 'home-page-wrapper ota-content3-wrapper' },
  page: { className: 'home-page ota-content3' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      { name: 'title', className: 'title-h1', children: 'product.ota.applicationScenario' },
      { name: 'sub-title', className: 'sub-title', children: 'APPLICATION SCENARIO' }
    ],
  },
  childWrapper: {
    className: 'ota-content3-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'ota-content3-block',
        active: true,
        children: {
          className: 'ota-content3-block-item',
          img: 'ota-03',
          subImg: 'ota-04',
          subActiveImg: 'ota-11',
          title: 'product.ota.carFactory',
          children: [
            {
              name: 'content',
              className: 'ota-content3-block-content',
              title: 'product.ota.carFactoryTitle01',
              children: 'product.ota.carFactoryContent01',
            },
            {
              name: 'content',
              className: 'ota-content3-block-content',
              title: 'product.ota.carFactoryTitle02',
              children: 'product.ota.carFactoryContent02',
            },
            {
              name: 'content',
              className: 'ota-content3-block-content',
              title: 'product.ota.carFactoryTitle03',
              children: 'product.ota.carFactoryContent03',
            },
            {
              name: 'content',
              className: 'ota-content3-block-content',
              title: 'product.ota.carFactoryTitle04',
              children: 'product.ota.carFactoryContent04',
            },
            {
              name: 'content',
              className: 'ota-content3-block-content',
              title: 'product.ota.carFactoryTitle05',
              children: 'product.ota.carFactoryContent05',
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'ota-content3-block',
        active: true,
        children: {
          className: 'ota-content3-block-item',
          img: 'ota-08',
          subImg: 'ota-06',
          subActiveImg: 'ota-10',
          title: 'product.ota.afterSale',
          children: [
            {
              name: 'content',
              className: 'ota-content3-block-content',
              title: 'product.ota.afterSaleTitle01',
              children: 'product.ota.afterSaleContent01',
            },
            {
              name: 'content',
              className: 'ota-content3-block-content',
              title: 'product.ota.afterSaleTitle02',
              children: 'product.ota.afterSaleContent02',
            },
            {
              name: 'content',
              className: 'ota-content3-block-content',
              title: 'product.ota.afterSaleTitle03',
              children: 'product.ota.afterSaleContent03',
            },
            {
              name: 'content',
              className: 'ota-content3-block-content',
              title: 'product.ota.afterSaleTitle04',
              children: 'product.ota.afterSaleContent04',
            }
          ],
        },
      }, {
        name: 'block2',
        className: 'ota-content3-block',
        active: true,
        children: {
          className: 'ota-content3-block-item',
          img: 'ota-05',
          subImg: 'ota-07',
          subActiveImg: 'ota-09',
          title: 'product.ota.vehicleOwner',
          children: [
            {
              name: 'content',
              className: 'ota-content3-block-content',
              title: 'product.ota.vehicleOwnerTitle01',
              children: 'product.ota.vehicleOwnerContent01',
            },
            {
              name: 'content',
              className: 'ota-content3-block-content',
              title: 'product.ota.vehicleOwnerTitle02',
              children: 'product.ota.vehicleOwnerContent02',
            },
            {
              name: 'content',
              className: 'ota-content3-block-content',
              title: 'product.ota.vehicleOwnerTitle03',
              children: 'product.ota.vehicleOwnerContent03',
            },
            {
              name: 'content',
              className: 'ota-content3-block-content',
              title: 'product.ota.vehicleOwnerTitle04',
              children: 'product.ota.vehicleOwnerContent04',
            },
          ],
        },
      },
    ],
  },
};
